import { omit } from 'lodash';
import API from 'services/API';
import { formatAddress, moment } from 'utils';

export default function getBooking(bookId) {
  return API.request({
    method: 'GET',
    url: `/appointment/booking?appointmentNumber=${bookId}`,
    mapper: function (data = []) {
      const appointment = (data[0] || {}).appointment || {};
      const taxAuthority = (data[0] || {}).taxAuthority || {};

      return {
        bookId: appointment.appointmentNumber,
        pincode: appointment.pin,
        window: appointment.window,
        serviceName: appointment.serviceName,
        visitTime: moment(appointment.visitDateTime),
        isCanceled: appointment.isCanceled === 'Y',
        cancelDate: appointment.cancelDate ? moment(appointment.cancelDate) : null,
        taxAuthority: Object.assign({}, omit(taxAuthority, ['fnsAddress']), {
          address: taxAuthority.fnsAddress ? formatAddress(taxAuthority.fnsAddress) : null,
        }),
      };
    },
  });
}
